require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-domain-experts-wanted.json") })
        }
      }, "path---blog-domain-experts-wanted");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-domain-experts-wanted!./.cache/json/blog-domain-experts-wanted.json
// module id = 778
// module chunks = 231608221292675